import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { serviceImages } from '../../constants/images';
import Footer from '../Footer';
const DigitalMarketing = () => {
  useEffect(() => {
    document.title = 'Digital Marketing - Global Excellence';
    window.scrollTo(0, 0);
  }, []);

  const features = [
    {
      icon: '🔍',
      title: 'Search Engine Optimization',
      description: 'Improve your website\'s visibility in search results'
    },
    {
      icon: '📱',
      title: 'Social Media Marketing',
      description: 'Engage with your audience across social platforms'
    },
    {
      icon: '📧',
      title: 'Email Marketing',
      description: 'Create effective email campaigns that convert'
    },
    {
      icon: '📊',
      title: 'Analytics & Reporting',
      description: 'Track and analyze your marketing performance'
    },
    {
      icon: '💰',
      title: 'PPC Advertising',
      description: 'Run targeted ad campaigns for maximum ROI'
    },
    {
      icon: '✍️',
      title: 'Content Marketing',
      description: 'Create valuable content that attracts and retains customers'
    }
  ];

  const processSteps = [
    {
      number: '01',
      title: 'Analysis',
      description: 'Audit your current digital presence and identify opportunities'
    },
    {
      number: '02',
      title: 'Strategy',
      description: 'Develop a comprehensive digital marketing strategy'
    },
    {
      number: '03',
      title: 'Implementation',
      description: 'Execute campaigns across multiple channels'
    },
    {
      number: '04',
      title: 'Monitoring',
      description: 'Track performance and gather insights'
    },
    {
      number: '05',
      title: 'Optimization',
      description: 'Continuously improve based on data'
    },
    {
      number: '06',
      title: 'Reporting',
      description: 'Provide detailed reports and recommendations'
    }
  ];

  const technologies = [
    { icon: '📈', name: 'Google Analytics' },
    { icon: '🔍', name: 'SEMrush' },
    { icon: '📱', name: 'Hootsuite' },
    { icon: '📧', name: 'Mailchimp' },
    { icon: '🔗', name: 'Ahrefs' },
    { icon: '🎨', name: 'Canva' },
    { icon: '🌐', name: 'WordPress' },
    { icon: '💰', name: 'Google Ads' }
  ];

  return (
    <>
    <div className="service-component-wrapper">
      {/* Hero Section */}
      <section className="service-component-hero">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="service-hero-content"
        >
          <h1 className="service-hero-title">Digital Marketing</h1>
          <p className="service-hero-subtitle">
            Drive growth through strategic digital marketing solutions
          </p>
        </motion.div>
      </section>

      {/* Overview Section */}
      <section className="service-overview">
        <div className="service-overview-content">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="service-overview-text"
          >
            <h2>Comprehensive Digital Marketing Solutions</h2>
            <p>
              Our digital marketing services help businesses establish a strong online presence,
              attract qualified leads, and convert them into loyal customers. We combine data-driven
              strategies with creative execution to deliver measurable results.
            </p>
          </motion.div>
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            className="service-overview-image"
          >
            <img src={serviceImages.digitalMarketing} alt="Digital Marketing" />
          </motion.div>
        </div>
      </section>

      {/* Features Section */}
      <section className="service-features">
        <h2>Our Digital Marketing Services</h2>
        <div className="features-grid">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="feature-card"
            >
              <span className="feature-icon">{feature.icon}</span>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Process Section */}
      <section className="service-process">
        <h2>Our Digital Marketing Process</h2>
        <div className="process-grid">
          {processSteps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="process-card"
            >
              <span className="process-number">{step.number}</span>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Technologies Section */}
      <section className="service-technologies">
        <h2>Tools & Technologies</h2>
        <div className="tech-grid">
          {technologies.map((tech, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="tech-item"
            >
              <span className="tech-icon">{tech.icon}</span>
              <span className="tech-name">{tech.name}</span>
            </motion.div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="service-cta">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="cta-content"
        >
          <h2 style={{color: 'white'}}>Ready to Boost Your Digital Presence?</h2>
          <p style={{color: 'white'}}>Let's discuss how we can help you achieve your marketing goals</p>
          <div className="cta-buttons">
            <Link to="/contactus" className="cta-button primary">
              Get Started
            </Link>
            <Link to="/services" className="cta-button secondary">
              View All Services
            </Link>
          </div>
        </motion.div>
      </section>
    </div>
    <Footer />
    </>
  );
};

export default DigitalMarketing; 